@if (showNavigation) {
  <app-navigation>
    <div class="container panel">
      <router-outlet></router-outlet>
    </div>
  </app-navigation>
} @else {
  <router-outlet></router-outlet>
}

